import React, { useEffect, useState, useContext } from "react";
import { useAlert } from 'react-alert';
import { UserContext } from "../../UserContext";

import CenteredPageContainer from "../components/layout_components/CenteredPageContainer";
import CardLayout from "../components/layout_components/CardLayout";
import { TextInput, SelectInput } from "../components/common_components/Forms";
import Button from "../components/common_components/Button";

import TimezoneList from "../../../user_portal/preauth_portal/components/TimezoneList";

// API Calls
import UserDemographicAPI from "../api/api_calls/UserDemographicAPI";



function ProfilePage(props) {
    const { user, setUser, refreshUser } = useContext(UserContext);
    const alert = useAlert();

    const [formData, setFormData] = useState({
        timezone: user.timezone,
        country: user.country,
    });
    const [errors, setErrors] = useState({});

    useEffect(() => {
        document.title = 'Profile | Despark';
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevents page reload
        setErrors({}); // Clear previous errors

        try {
            const data = await UserDemographicAPI.update({ timezone: formData.timezone });

            if (data.success) {
                alert.show("Profile updated", { type: 'success' });
                refreshUser();
            } else {
                if (data.error) {
                    alert.show(data.error, { type: 'error' });
                } else {
                    alert.show("Unable to update profile", { type: 'error' });
                }
            }
        } catch (error) {
            console.error("Error updating profile:", error);
            alert.show("An unexpected error occurred.", { type: 'error' });
        }
    };


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };



    return (
        <CenteredPageContainer>
            <CardLayout>
                <div className="profile-header-container">
                    <h1>Profile</h1>
                    <div className="body-small black-500-text">
                        Your profile information is visible to the researchers whose missions you have applied to.
                    </div>
                </div>
                <form className="profile-form" onSubmit={handleSubmit}>
                    <TextInput
                        label="First Name / Pseudonym"
                        name="first_name"
                        placeholder="First Name"
                        value={user.first_name}
                        disabled={true}
                        readOnly={true}
                    />
                    <TextInput
                        label="Country"
                        name="country"
                        value={formData.country}
                        disabled={true}
                        readOnly={true}
                    />
                    <SelectInput
                        label="Timezone"
                        name="timezone"
                        onChange={handleChange}
                        value={formData.timezone}
                        error={errors.timezone}
                        options={
                            TimezoneList.map((timezone) => ({ value: timezone, label: timezone }))
                        }
                    />
                    <Button type="submit">Submit</Button>
                </form>
            </CardLayout>
        </CenteredPageContainer>
    )
}


export default ProfilePage